<template>
  <node-view-wrapper
    as="span"
    :class="classObject"
    :data-id="id"
    :data-type="type"
  >
    <span @click="onClick">{{ label }}</span>
  </node-view-wrapper>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import emitter from 'tiny-emitter/instance';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { EVENT } from '../../constants.js';

export default {
  components: {
    NodeViewWrapper,
  },

  props: {
    node: {
      type: Object,
      default: null,
    },
    updateAttributes: {
      type: Function,
      default: () => {},
    },
    extension: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('project/data/components', {
      getComponentMention: 'getMention',
    }),
    ...mapGetters('project/data/boards', { getBoardMention: 'getMention' }),
    ...mapGetters('project/data/elements', {
      getElementMention: 'getMention',
      getElement: 'getNode',
      getContainerNode: 'getContainerNode',
    }),

    id: {
      get() {
        return this.node.attrs.id;
      },
      set(value) {
        this.updateAttributes({ id: value });
      },
    },
    type: {
      get() {
        return this.node.attrs.type;
      },
      set(value) {
        this.updateAttributes({ type: value });
      },
    },
    /**
     * The mention object
     */
    mention: {
      get() {
        let m = null;
        switch (this.type) {
          case 'component':
            m = this.getComponentMention(this.id);
            break;
          case 'board':
            m = this.getBoardMention(this.id);
            break;
          case 'element':
            m = this.getElementMention(this.id);
            break;
          default:
            break;
        }
        return m;
      },
    },
    /**
     * The mention label
     */
    label: {
      get() {
        if (this.mention) {
          return this.extension.options.renderLabel({
            options: this.extension.options,
            node: this.node,
          });
        }

        return null;
      },
    },
    /**
     * Dynamically applied class
     */
    classObject: {
      get() {
        return {
          mention: true,
          'mention-component': this.type === 'component',
          'mention-board': this.type === 'board',
          fromComponent: true,
        };
      },
    },
  },

  watch: {
    label(newVal, oldVal) {
      this.labelText = newVal || oldVal;
    },
  },

  methods: {
    ...mapActions('project/config/components', { setOpenComponent: 'setOpen' }),
    ...mapActions('project/config/boards', { setOpenBoard: 'setOpen' }),
    /**
     * A mention was clicked
     * @param {Object} event
     */
    onClick(event) {
      console.log('Mention click');
      if (this.type === 'component') {
        this.setOpenComponent({
          id: this.id,
          apply: true,
        });
      } else if (this.type === 'board') {
        this.setOpenBoard({
          id: this.id,
          apply: true,
        });
      } else if (this.type === 'element') {
        const element = this.getElement(this.id);
        emitter.emit(EVENT.ZOOMTONODE, {
          node: element,
          type: 'elements',
          boardId: this.getContainerNode(this.id, 'boards', 'elements').id,
        });
      }
    },
  },
};
</script>
